/* ===================================================================
   KARUSELLI  →  assets/carousel.js
   Jaettu karusellilogiikka. Alustaa KAIKKI .pcarousel-elementit sivulla.
   Käytössä: product-carousel-sektio + katalogin alaosastokaruselli.
   =================================================================== */
  (function(){
    function initCarousel(root){
    if(!root || root.dataset.carouselInit) return;
    root.dataset.carouselInit = '1';
    var viewport = root.querySelector('[data-carousel-viewport]');
    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var bar = root.querySelector('[data-carousel-bar]');
    var thumb = root.querySelector('[data-carousel-thumb]');
    if(!track) return;

    function gap(){
      var s = getComputedStyle(track);
      return parseInt(s.columnGap || s.gap || '24', 10);
    }
    // Montako korttia mahtuu näkyviin kerralla (= yksi "sivu")
    function perView(){
      var item = track.querySelector('.pcarousel__item');
      if(!item) return 1;
      return Math.max(1, Math.round(track.clientWidth / (item.offsetWidth + gap())));
    }
    function pageWidth(){
      var item = track.querySelector('.pcarousel__item');
      if(!item) return track.clientWidth;
      return (item.offsetWidth + gap()) * perView();
    }

    // --- Scrollbar: thumb-leveys = näkyvä osuus, sijainti = edistymä ---
    function scrollable(){ return track.scrollWidth - track.clientWidth; }
    function buildBar(){
      if(!bar || !thumb) return;
      var ratio = track.clientWidth / track.scrollWidth;
      if(ratio >= 0.999){ bar.classList.add('is-hidden'); return; }
      bar.classList.remove('is-hidden');
      thumb.style.width = Math.max(12, ratio * 100) + '%';
      syncBar();
    }
    function syncBar(){
      if(!bar || !thumb) return;
      var max = scrollable();
      if(max <= 0) return;
      var progress = track.scrollLeft / max;                 // 0..1
      var travel = bar.clientWidth - thumb.offsetWidth;       // px thumb voi liikkua
      thumb.style.transform = 'translateX(' + (progress * travel) + 'px)';
    }

    // --- Nuolten tila + dotit + fade ---
    function update(){
      var max = track.scrollWidth - track.clientWidth - 1;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= max;
      if(prev) prev.disabled = atStart;
      if(next) next.disabled = atEnd;
      if(viewport){
        viewport.classList.toggle('has-prev', !atStart);
        viewport.classList.toggle('has-next', !atEnd && max > 0);
      }
      syncBar();
    }

    if(prev) prev.addEventListener('click', function(){ track.scrollBy({left:-pageWidth(),behavior:'smooth'}); });
    if(next) next.addEventListener('click', function(){ track.scrollBy({left:pageWidth(),behavior:'smooth'}); });

    track.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', function(){ buildBar(); update(); });

    // --- Scrollbarin klikkaus/veto = hyppää kohtaan ---
    function scrubTo(clientX){
      var rect = bar.getBoundingClientRect();
      var ratio = (clientX - rect.left) / rect.width;
      ratio = Math.max(0, Math.min(1, ratio));
      track.scrollLeft = ratio * scrollable();
    }
    if(bar){
      var barDown = false;
      bar.addEventListener('mousedown', function(e){ barDown = true; scrubTo(e.clientX); e.preventDefault(); });
      window.addEventListener('mousemove', function(e){ if(barDown) scrubTo(e.clientX); });
      window.addEventListener('mouseup', function(){ barDown = false; });
    }

    // --- Hiirivetäminen itse korteista ---
    var down=false, startX=0, startScroll=0, moved=0, dragging=false;
    track.addEventListener('mousedown', function(e){
      down=true; moved=0; dragging=false;
      startX=e.pageX; startScroll=track.scrollLeft;
      // EI lisätä is-dragging tässä — muuten linkit menevät heti pointer-events:none
    });
    window.addEventListener('mousemove', function(e){
      if(!down) return;
      var dx = e.pageX - startX;
      moved = Math.abs(dx);
      // aktivoi drag vasta kun oikeasti liikutaan (kynnys 4px)
      if(!dragging && moved > 4){
        dragging=true;
        track.classList.add('is-dragging');
      }
      if(dragging){ track.scrollLeft = startScroll - dx; }
    });
    window.addEventListener('mouseup', function(){
      if(!down) return;
      down=false;
      track.classList.remove('is-dragging');
    });
    // estä linkkiklikkaus vain jos oli oikea veto
    track.addEventListener('click', function(e){
      if(moved > 6){ e.preventDefault(); e.stopPropagation(); }
    }, true);

    buildBar();
    update();
    }

    function initAll(){
      document.querySelectorAll('.pcarousel').forEach(initCarousel);
    }
    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    // Theme editor: alusta uudelleen kun sektio lisätään/ladataan
    document.addEventListener('shopify:section:load', function(e){
      var el = e.target.querySelector ? e.target.querySelector('.pcarousel') : null;
      if(el) initCarousel(el);
    });
  })();